// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labels-style[data-v-ff362f3a]{font-size:.9rem;font-weight:700}.indication-style[data-v-ff362f3a]{font-size:.95rem;font-weight:700}.v-expansion-panel>.v-expansion-panel-header[data-v-ff362f3a]{background:#a3c3db!important;font-weight:500!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
